import React, { useState } from 'react'
import ProductQuantity from '@molecules/ProductQuantity/ProductQuantity'
import Availability from '@atoms/Availability/Availability'
import VariantSelector from '@atoms/VariantSelector/VariantSelector'
import Modal from '@molecules/Modal/Modal'
import BaseRichTextComponent from '@cms/RichText/BaseRichTextComponent'
import PriceTag from './PriceTag'
import * as T from './CommerceBox.types'
import { useConfig } from 'msp-integrations'

const isEmpty = require('lodash/isEmpty')

const CommerceBoxMD = ({
  product,
  CTAButton,
  innerRef,
  isPDP = false,
  onAddToCart,
  onVariantChange,
  noPadding,
  showTaxesInfo = true,
  smallDiscountPrice = false,
  displayExtendedInfo,
  WishlistButton,
  wishlistButtonOnRight = false,
  showLowestPrice
}: T.CommerceBoxMDProps) => {
  const {
    theme: { font }
  } = useConfig()
  const {
    id,
    price,
    c_basePrice,
    c_priceDiscounted,
    c_minSetPrice,
    currency,
    inventory,
    c_inventory,
    c_isGiftcard,
    variants,
    variationAttributes,
    variant,
    quantity = 1,
    c_basketLimit,
    c_usps = [],
    c_classCategoryID,
    c_promotionCondition,
    c_promotionConditionLink,
    c_lastMonthPrice,
    c_lastMonthPriceCallback
  } = product
  const [openModalPromoCondition, setOpenModalPromoCondition] = useState(false)
  const [selectedQuantity, setSelectedQuantity] = useState(quantity)
  const { ats, orderable, preorderable, stockLevel, inStockDate } =
    inventory || c_inventory || {}

  const richTextData = {
    data: {
      richText: {
        value: c_promotionCondition || ''
      },
      hasCustomStyle: true
    },
    className: `${font.regular} flex flex-col w-full text-14 leading-24`
  }
  const ModalPromoConditionBody = () => (
    <BaseRichTextComponent {...richTextData} />
  )

  return (
    <div
      className={`grid max-w-md grid-rows-1 gap-5 ${noPadding ? '' : 'p-3'}`}
      ref={innerRef}
    >
      {variants && variants.length > 0 && onVariantChange && (
        <VariantSelector
          variants={variants}
          variationAttributes={variationAttributes}
          variantSelected={variant}
          onVariantChange={onVariantChange}
          isGiftCert={c_classCategoryID === 'giftcards'}
          isPDP={isPDP}
        />
      )}
      <PriceTag
        className='grid auto-cols-fr grid-flow-col grid-cols-[auto] items-center gap-4'
        discountPrice={c_priceDiscounted}
        c_basePrice={c_basePrice}
        price={c_minSetPrice || price}
        smallDiscountPrice={smallDiscountPrice}
        showTaxesInfo={showTaxesInfo}
        currency={currency}
        isPDP={isPDP}
        alignBasePriceRight
        showLowestPrice={showLowestPrice}
        lastMonthPrice={c_lastMonthPrice}
        lastMonthPriceCallback={c_lastMonthPriceCallback}
      />
      <div className='flex items-center justify-between space-x-4'>
        <div>
          <ProductQuantity
            productId={id}
            selectedQuantity={selectedQuantity}
            disabled={!orderable || c_isGiftcard || !!product?.type?.set}
            limit={c_basketLimit}
            width={'w-fit'}
            onChange={(quantity) => setSelectedQuantity(quantity)}
          />
        </div>
        <div
          className={`flex flex-row space-x-1 ${
            wishlistButtonOnRight
              ? 'flex-row-reverse space-x-reverse'
              : 'flex-row'
          }`}
        >
          {WishlistButton && <div>{WishlistButton}</div>}
          <div
            className={`flex w-full ${
              !orderable ? 'cursor-not-allowed' : 'cursor-pointer'
            }`}
            onClick={() => {
              if (onAddToCart && orderable) {
                onAddToCart(selectedQuantity || 1)
              }
            }}
          >
            {CTAButton}
          </div>
        </div>
      </div>
      <div>
        {(!isEmpty(inventory) || !isEmpty(c_inventory)) && (
          <Availability
            ats={ats}
            stockLevel={stockLevel}
            inStockDate={inStockDate}
            orderable={orderable}
            preorderable={preorderable}
          />
        )}
      </div>
      {isPDP && c_usps.length > 0 && (
        <div
          className={`${font.regular} text-grayRegular text-14 tracking-0.4 flex w-full flex-col pt-4`}
        >
          {c_usps.map((usp, index) => {
            return (
              <div className='leading-28' key={`usp-unique-id-${index}`}>
                {usp}
              </div>
            )
          })}
        </div>
      )}
      {displayExtendedInfo &&
        !isEmpty(c_promotionCondition) &&
        !isEmpty(c_promotionConditionLink) && (
          <>
            <div
              className={`${font.regular} text-grayRegular text-14 leading-16 tracking-0.2 flex w-full cursor-pointer flex-col pt-4 text-right underline`}
              onClick={() => setOpenModalPromoCondition(true)}
            >
              {c_promotionConditionLink}
            </div>
            <Modal
              isExtended={true}
              isOpen={openModalPromoCondition}
              onClose={() => setOpenModalPromoCondition(false)}
              overlay
              closeOnOverlayClick
              blockScroll
              modalBody={<ModalPromoConditionBody />}
            />
          </>
        )}
    </div>
  )
}

export default CommerceBoxMD
